import { ColorIconHelper } from '@/hub-shared'
import { useLayoutEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './importance.component.scoped.scss'

export default () => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const colorIconHelper = useMemo(() => new ColorIconHelper(), [])

  const { t } = useTranslation('modalVinculateSocialNetwork')

  const listImportance = [t('listImportanceInstagram.1'), t('listImportanceInstagram.2'), t('listImportanceInstagram.3')]

  useLayoutEffect(() => {
    const updateWidthAndHeight = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }

    window.addEventListener('resize', updateWidthAndHeight)

    return () => window.removeEventListener('resize', updateWidthAndHeight)
  })

  return (
    <div className="wrapper-importance justify-content-start" style={{ height: width < 991 ? `calc(${height}px - 204px)` : 'auto' }}>
      <h4 className="title display-flex align-items-center">
        {[
          <i key="instagram-icon" className={`fa-brands fa-${colorIconHelper?.setIcon('instagram')} mr-2`} />,
          <i key="facebook-icon" className={`fa-brands fa-${colorIconHelper?.setIcon('facebook')} mr-3`} />,
          <span key="instagram-text">Instagram / Facebook</span>,
        ]}
      </h4>

      <section className="description">
        <p dangerouslySetInnerHTML={{ __html: t('selectSocialNetworkDescription') }} />
      </section>

      <ul className="list-importance-connect align-self-start">
        {listImportance?.map((item, index) => (
          <li key={index} className="display-flex align-items-center">
            <i className="fa-regular fa-check"></i>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
